// move functions in scripts.js after testing - just keep codes inside the DOMContentLoaded

const DEV_ACCESS_TOKEN = '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'
const WISHLIST_NAMESPACE = 'custom'
const WISHLIST_KEY = 'wishlist'

// set namespace and key in param,  function can be reused on other meta data
const getCustomerMetafield = async (customerId, namespace, key) => {
    if (!customerId || !namespace || !key) {
        return null;
    }

    const res = await fetch(`${firebaseFunctions}/get-customer-metafield`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ customerId, namespace, key })
    })
    const data = await res.json();
    return data || null;
};
const updateCustomerMetafield = async (customerId, namespace, key, value, value_type = 'json_string') => {
    if (!customerId || !namespace || !key || !value) {
        return null;
    }

    const res = await fetch(`${firebaseFunctions}/update-customer-metafield`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ customerId, namespace, key, value, value_type })
    })
    const data = await res.json();
    return data || null;
};

const checkIfAlreadyinWishlist = (productId, variantId = null) => {
    if (Array.isArray(window.wishlist)) {
        return window.wishlist.find(item => item.productId === productId && item.variantId === variantId)
    } return false
}

const addProductToWishlist = async (productId, variantId = null, uom = null, handle = null) => {
    if (!checkIfAlreadyinWishlist(productId, variantId)) {
        if (!Array.isArray(window.wishlist)) {
            window.wishlist = []
        }

        window.wishlist.push({productId, variantId, uom, handle})
        updateAddAllWishlistForm()
        const newData = await updateCustomerMetafield(window.customerId, WISHLIST_NAMESPACE, WISHLIST_KEY, JSON.stringify(window.wishlist));
        return newData
    }
}

const clearWishList = async () => {
    window.wishlist = []
    updateAddAllWishlistForm()
    const newData = await updateCustomerMetafield(window.customerId, WISHLIST_NAMESPACE, WISHLIST_KEY, JSON.stringify(window.wishlist));
    return newData
}

const getUserWishlist = async () => {
    const wishlist = await getCustomerMetafield(customerId, WISHLIST_NAMESPACE, WISHLIST_KEY)
    return JSON.parse(wishlist)
}

const removeFromWishList = async (data) => {
    const productID = data?.productId && data.productId !== 'null' ? data.productId : null
    const variantID = data?.variantId && data.variantId !== 'null' ? data.variantId : null
    window.wishlist = window.wishlist.filter(item => !(+item.productId === +productID && +item.variantId === +variantID))
    
    if (window.wishlist.length <= 3) {
        const scrollableTable = document.querySelector('.scrollable-table')
        if (scrollableTable) {
            scrollableTable.style.overflow = 'hidden'
        }
    }
    const newData = await updateCustomerMetafield(window.customerId, WISHLIST_NAMESPACE, WISHLIST_KEY, JSON.stringify(window.wishlist));
   
    updateAddAllWishlistForm()
    return newData
}

const variantToWishlist = () => {
    // product page
    document.querySelectorAll('form input[name="id"]').forEach(item => {
        const formElm = item.closest('form')
        if (formElm) {

            item.addEventListener('change', function () {
                const productId = formElm.querySelector('[name="product-id"]').value ?? null
                const variantId = item.value ?? null
    
                const wishlistButton = formElm.querySelector('.add-to-wishlist')
    
                if (wishlistButton) {
                    wishlistButton.setAttribute('data-variant-id', variantId)
                    if (checkIfAlreadyinWishlist(productId, variantId)) {
                        wishlistButton.textContent = 'Remove from Wishlist'
                        wishlistButton.classList.add('added')
                    } else {
                        wishlistButton.textContent = 'Add to Wishlist'
                        wishlistButton.classList.remove('added')
                    }
                }
            })
        }
    })

    // product card
    document.querySelectorAll('.card-product-variant-dropdown-select label').forEach(item => {
        item.addEventListener('click', function (e) {
            const formElm = item.closest('form')

            if (formElm) {
                const productId = formElm.querySelector('[name="product-id"]').value ?? null
                const variantId = item.dataset.value ?? null

                const wishlistButton = item.closest('form').querySelector('.add-to-wishlist')

                if (wishlistButton) {
                    wishlistButton.setAttribute('data-variant-id', variantId)
                    if (checkIfAlreadyinWishlist(productId, variantId)) {
                        wishlistButton.textContent = 'Remove from Wishlist'
                        wishlistButton.classList.add('added')
                    } else {
                        wishlistButton.textContent = 'Add to Wishlist'
                        wishlistButton.classList.remove('added')
                    }
                }
            }
        })
    })
}

const updateAddAllWishlistForm = () => {

    // add all wishlist to cart
    document.querySelectorAll('.--js-add-all-wishlist-to-cart').forEach(form => {

        if (form) {
            form.querySelector('.input-wrapper')?.remove();

            const wrapper = document.createElement('div')
            wrapper.classList.add('input-wrapper')

            if (Array.isArray(window.wishlist) && window.wishlist.length) {
                window.wishlist.forEach((item, index) => {
                    const input = document.createElement('input')
                    input.type='hidden'
                    input.name=`items[${index}][id]`
                    input.value=item?.variantId
    
                    wrapper.appendChild(input)
                })
            }

            form.appendChild(wrapper)
        }
    })
}
  
document.addEventListener('DOMContentLoaded', async function() {
    updateAddAllWishlistForm()
    document.querySelectorAll('.remove-from-wishlist').forEach(item => {
        item.addEventListener('click', function () {
            // remove from list
            const wishlistItem = item.closest('[wishlist-item]')
            if (wishlistItem) {
                const itemToRemove = wishlistItem.getAttribute('wishlist-item')
                if (itemToRemove) {
                    document.querySelectorAll(`[wishlist-item="${itemToRemove}"]`).forEach(wishItem => {
                        wishItem.remove()
                    })

                    if (document.querySelectorAll('[wishlist-item]').length === 0) {
                        const wishlistTable = document.querySelector('.wishlist-page .dataTables_wrapper')
                        if (wishlistTable) {
                            wishlistTable.classList.add('hidden')
                        }
                        const wishlistNoData = document.querySelector('.wishlist-page .no-wishlist-data')
                        if (wishlistNoData) {
                            wishlistNoData.classList.remove('hidden')
                        }

                    }
                }
            }

            // remove from shopify
            removeFromWishList(item.dataset);
        })
    })

    if (window.customerId) {
        const metafieldValue = await getCustomerMetafield(window.customerId, WISHLIST_NAMESPACE, WISHLIST_KEY)
        window.wishlist = metafieldValue || []
        
    }

    // add listener on variant change
    variantToWishlist()
})